$(document).ready(function () {
  const setCurrentCurrency = function() {
    const currentCurrency = $('.switch-currency-container .active').text().replace(/^\s+|\s+$/g,'');
    $('.currency-choice').val(currentCurrency == 'Euro' ? 'eur' : 'chf');
  }

  if ($('#xlsxModal, #pdfModal').length) {
    setCurrentCurrency();
  }

  if ($('#profilesFilterForm, #subscriptionsFilterForm').length) {
    var timerThrottle;
    var timerDebounce;

    var submitForm = function () {
      // set currency before submitting form
      setCurrentCurrency();
      setStatus();

      // fetch filter value from search_bar and set it as hidden field for the export modal
      setSearchBarValueToExportForm();
      setfilterSelectToExportForm();

      document.getElementById('submitForm').click();
    }

    var setStatus = function() {
      if ($('.status-choice').length) {
        currentStatus = $('.switch-container input:checked').val();
        $('.status-choice').val(currentStatus);
      }
    }

    var setSearchBarValueToExportForm = function() {
      if ($("#searchBar").length) {
        let searchBarValue = $("#searchBar").val();
        if (searchBarValue.length) {
          $("#searchBarValue").val(searchBarValue);
        }
      }
    }

    var setfilterSelectToExportForm = function() {
      if ($("#tagSelect").length) {
        let filterSelect = $("#tagSelect").val();
        if (filterSelect.length) {
          $("#filterSelect").val(filterSelect);
        }
      }
    }

    var debounceFunction = function (func, delay) {
      // Cancels the setTimeout method execution
      clearTimeout(timerDebounce);

      // Executes the func after delay time.
      timerDebounce  =  setTimeout(function () {
        throttleFunction(func, 500)
      }, delay);
    }

    var throttleFunction  =  function (func, delay) {
      // If setTimeout is already scheduled, no need to do anything
      if (timerThrottle) {
        return
      }

      // Schedule a setTimeout after delay seconds
      timerThrottle  =  setTimeout(function () {
        func()

        // Once setTimeout function execution is finished, timer = undefined so that in <br>
        // the next scroll event function execution can be scheduled by the setTimeout
        timerThrottle  =  undefined;
      }, delay)
    }

    $('#tagSelect').on('change', function() {
      submitForm();
    });

    $('#searchBar').on('keyup', function() {
      if ($(this).val().length >= 2 || $(this).val().length == 0) {
        debounceFunction(submitForm, 500);
      }
    });

    // Submit every time project status filter is updated
    $(document).on('click', '#q_g_0_project_status_project_status_not_eqrefunded.left', submitForm);
    $(document).on('click', '#q_g_0_project_status_project_status_eqrefunded.right', submitForm);

    if ($("input[name='q[ransack_scope]']").length) {
      $("input[name='q[ransack_scope]']").on('change', function() {
        submitForm();
        $('.switch-section #not_paid, .switch-section #paid').toggleClass('fw-semi-bold');
      })

      if ($("input[name='q[ransack_scope]']:checked").val() == 'finalized') {
        submitForm();
        $('.switch-section #paid').addClass('fw-semi-bold');
      } else {
        $('.switch-section #not_paid').addClass('fw-semi-bold');
      }
    }
  }
});
